package one.healthium.login.ui.login

import androidx.compose.runtime.Immutable
import one.healthium.domain.user.UserModel

@Immutable
data class LoginUiState(
    val loading: Boolean = false,
    val signInOptions: SignInUiOptions = SignInUiOptions(),
    val user: UserModel? = null,
)
